import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { AssessmentService } from './assessment.service';
import { CommonService } from './common.service';
import { QuestionValidationService } from './question-validation.service';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class QuestionControlService {

  formData: any;
  zones: any;
  allCountries: any;
  isArabic: any;
  userDetails: any;
  assessmentDetails: any;
  isChecker: any;
  quesDescription: any;
  constructor(private httpClient: HttpClient, private quesValidationService: QuestionValidationService,
    private fb: FormBuilder, private assessmentService: AssessmentService, private commonService: CommonService,
    private storageService: StorageService) {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.assessmentDetails = this.storageService.getSessionStorageData('assessmentDetails');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
  }

  toFormGroup(zones: any, form: FormGroup, allQuesAnswer?: any): FormGroup {
    zones?.forEach((zone: any) => {
      form = this.generateEachZone(zone, form, allQuesAnswer);
      // console.log('form is:::::::::', form);
    });
    return form;
  }

  generateEachZone(zone: any, form: any, allAnswers?: any, populateSubField?: boolean) {
    zone?.fields.forEach((question: any) => {
      if (question.controlType !== 'button') {
        question.controls.forEach((quesControl: any, controlIndex: any) => {
          if (quesControl.dependsOn) {
            // if (quesControl?.linkedChild &&
            //   quesControl?.linkedChild?.length > 0) {
            const parentQuesId = quesControl.dependsOn + '_id_0';
            let parentQuesResp = typeof (form.get(parentQuesId)?.value) !== 'string' ?
              form.get(parentQuesId)?.value?.toString() : form.get(parentQuesId)?.value;
            if (quesControl.basedOnValue?.toLowerCase() === parentQuesResp?.toLowerCase()) {
              quesControl.isHidden = false;
              question.isHidden = false;
            } else {
              // } else if(question.isHidden){
              let parentIdx = zone?.fields?.findIndex((quesParent: any) =>
                quesParent?.quesId == quesControl?.dependsOn);
              if (parentIdx > -1) {
                if (zone?.fields[parentIdx]?.controls[0]?.type == 'multiselect') {
                  let parentQuesRespArr = parentQuesResp?.split(',');
                  let idx = parentQuesRespArr?.findIndex((eleResp: any) =>
                    eleResp?.toLowerCase() == quesControl?.basedOnValue?.toLowerCase());
                  if (idx > -1) {
                    quesControl.isHidden = false;
                    question.isHidden = false;
                  } else {
                    quesControl.isHidden = true;
                    question.isHidden = true;
                  }
                } else {
                  quesControl.isHidden = true;
                  question.isHidden = true;
                }
              } else {
                quesControl.isHidden = true;
                question.isHidden = true;
              }
            }
          }
          // }
          form = this.createControl(form, question, quesControl, controlIndex, allAnswers);
        });
      }
    });
    return form;
  }

  createControl(form: any, question: any, quesControl: any, controlIndex: any, allAnswers?: any) {
    let validators = [];
    if (quesControl.type == null) {
      quesControl.type = 'textbox';
      quesControl.label = '';
    }
    if (quesControl.validation && quesControl.validation !== {} && !quesControl.isHidden && (quesControl.isDisabled == undefined || !quesControl.isDisabled)
    ) {
      validators = this.quesValidationService.addValidation(quesControl.validation);

    } else {

    }
    if (!!allAnswers) {
      question = this.setControlValue(question, quesControl, controlIndex, allAnswers);
    }
    form?.addControl(
      question.quesId + '_id_' + controlIndex,
      this.fb.control(quesControl.value, validators)
    );
    return form;
  }

  // toggleSubFieldsByEvent(form: any, allQuestions:any, parentQuesAns:any, questionaireguid:any, quesguid: any, 
  //   questionnaireType:any, questionnaireAccountGuid:any, responseId:any, isResubmit:any, isChecker:any,
  //   isMakerCheckerEnabled:any, status:any, comments:any) {  
  //   console.log('parentQuesAns',parentQuesAns);
  //   let saveNullValue = false;
  //   let selectedQuesControlId = parentQuesAns?.parentQuesId;
  //   let questionguid = quesguid;
  //   let parentQuesVal = (typeof(parentQuesAns.parentQuesValue) !== 'string') ? parentQuesAns.parentQuesValue?.toString() : parentQuesAns.parentQuesValue;
  //   allQuestions[0].fields.forEach((question: any) => {
  //     question.controls.forEach((quesControl: any, controlIndex: any) => {
  //       console.log('quesControl.dependsOn', quesControl.dependsOn);
  //       if(quesControl.dependsOn && (quesControl.dependsOn+'_id_'+controlIndex === parentQuesAns?.parentQuesId)) {
  //             if(quesControl.basedOnValue?.toLowerCase() == 'any' || quesControl.basedOnValue == '' ||
  //             quesControl.basedOnValue?.toLowerCase() === parentQuesVal?.toLowerCase()) {
  //               quesControl.isHidden = false;
  //               question.isHidden = false;
  //             } else {
  //               form.get(question.quesId+'_id_'+controlIndex).setValue(null);
  //               quesControl.isHidden = true;
  //               quesControl.value = null;
  //               question.isHidden = true;
  //               this.quesDescription = question.label;
  //               saveNullValue = true;
  //               selectedQuesControlId = question.quesId+'_id_'+controlIndex;
  //               questionguid = question.quesguid;
  //           }
  //       }
  //     });
  //   });
  //       if(saveNullValue) {
  //         const rqstBody = {
  //           designRating: null, 
  //           operatingRating: null, 
  //           executorResponse : '',
  //           assessmentunitguid :this.assessmentDetails.assessmentunitguid,
  //           quesnaireguid : questionaireguid,
  //           quesnaireaccountguid : questionnaireAccountGuid,
  //           quesguid : questionguid,
  //           contactguid : this.userDetails.contactguid,
  //           quesSubmitTime : new Date(),
  //           quesDesc: this.quesDescription,
  //           assessmentType : questionnaireType,
  //           responseId : responseId,
  //           isResubmit : isResubmit,
  //           isChecker : isChecker,
  //           isMakerCheckerEnabled : isMakerCheckerEnabled,
  //           checkerApprovalStatus : status,
  //           comments : (comments == undefined || comments == 'undefined' || 
  //           comments == null || comments == 'null' || comments.trim() == '') ? '' : comments
  //         }
  //         console.log('rqstbody in toggle: ',rqstBody);
  //         this.assessmentService.saveQuestionResponse(rqstBody).subscribe((data:any) => {
  //           let decryptedData = this.commonService.decryptUsingAES256(data?.data);
  //           if(decryptedData?.isDrafted === true) {
  //             this.toggleSubFieldsByEvent(form, allQuestions, 
  //               {parentQuesId: selectedQuesControlId, parentQuesValue: null}, questionaireguid, quesguid, questionnaireType,
  //               questionnaireAccountGuid, responseId, isResubmit, isChecker,
  //               isMakerCheckerEnabled, status, comments);
  //           }
  //         });
  //       }

  //     return {allQuestions, form};
  // }

  setControlValue(question: any, quesControl: any, controlIndex: any, allAnswers?: any) {
    // console.log('all answers',allAnswers);
    // console.log('questions',question);
    const answer = allAnswers.find((eachAnswer: any) => eachAnswer.ques === question.quesguid);
    let executorResp: any = [];
    if (answer?.quesResponse !== null) {

      if (answer?.quesResponse?.indexOf(';') > -1) {
        executorResp = answer?.quesResponse.split(';');
      } else {
        executorResp[0] = answer?.quesResponse;
      }
      // console.log('executor', executorResp);
      question.controls[controlIndex].value = executorResp[controlIndex];

    }
    question.responseId = answer?.responseId;
    question.comments = answer?.comments;
    question.commentHistory = answer?.commentHistory;
    question.statusOfResponse = answer?.statusOfResponse;

    return question;
  }

  fetchForm(formName: string): Observable<any> {
    return this.httpClient.get('./assets/data/' + formName + '.json');
  }

}
